<script setup lang="ts">
import MultiComboboxInput from '@/components/selectBox/combobox/MultiComboboxInput.vue';
import { useProgramsSearch } from '@/hooks/search/useProgramsSearch';
import { Selectable } from '@/components/selectBox/selectBox';

const { programOptions, isLoading, onQueryChange } = useProgramsSearch();

defineProps<{
  modelValue: Selectable<number>[];
}>();

defineEmits(['update:modelValue']);
</script>

<template>
  <MultiComboboxInput
    :options="programOptions"
    :onFilter="onQueryChange"
    :isLoading="isLoading"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    @open="() => onQueryChange('')"
  />
</template>
